export enum SigningType {
  NoSigning = 0,
  SignRequired = 1,
  Signed = 2
}

export class SigningTypeConverter{

  public static GetValueById(enumText:string):number {

    switch (enumText) {
      case 'NoSigning':
        return 0;
      case 'SignRequired':
        return 1;
      case 'Signed':
        return 2;
    }

    return 0;

  }
    

  public static getSigningTranslation(linkType: string) {
    switch (linkType) {
      case 'NoSigning':
        return "Без Подпис";
      case 'SignRequired':
        return "Изисква Подпис";
      case 'Signed':
        return "Подписан";
    }

    return "";
  }

}
